module.exports = __webpack_public_path__ + "img/LogoFiveaDay.4ac7e2b8.png";